import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { ReactComponent as ForkIcon4 } from "../../assets/icons/Fork4.svg";
import { ReactComponent as ForkIcon3 } from "../../assets/icons/Fork3.svg";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
const ProductInfo = () => {
  const esentialItems = [
    {
      title: "Installs & Reinstalls",
      description: "See how effectively your user acquisition is performing.",
    },

    {
      title: "Reactivations",
      description: "Identify the campaigns and channels bringing users back.",
    },

    {
      title: "App Opens",
      description: "Understand frequency of user engagement.",
    },

    {
      title: "Link Views",
      description: "Track user journeys from initial click to app interaction.",
    },
  ];
  const deepLinkingItems = [
    {
      title: "Smart Routing",
      description:
        "Send users directly to specific content or features within your app.",
    },

    {
      title: "Deferred Linking",
      description:
        "Even if users install your app after clicking, they’ll seamlessly continue their intended journey post-install.",
    },

    {
      title: "Fully Editable Links",
      description:
        "Update and optimize destinations and link details anytime, even after launching a campaign.",
    },
  ];
  const automatedMessagingItems = [
    {
      title: "New vs. Existing Users",
      description:
        "Create targeted messages tailored to each user group’s experience.",
    },

    {
      title: "Platform-Specific Messaging",
      description: "Show distinct messages for users on iOS, Android, or Web.",
    },

    {
      title: "In-App Inbox",
      description:
        "Messages are organized neatly for users to access anytime, reducing frustration and improving engagement.",
    },
  ];

  return (
    <FullPageContainer>
      <Container id={"productInfo"}>
        <Content>
          <TextWrapper>
            <Title>Essential Data, Clearly Delivered</Title>
            <Subtitle>
              Grovs automatically tracks critical lifecycle events to help your
              product team understand exactly how users interact with your app.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon4 color="rgba(13, 52, 49, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {esentialItems.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
        <Content>
          <TextWrapper>
            <Title>Seamless Deep Linking, Zero Friction</Title>
            <Subtitle>
              Grovs’ powerful deep linking ensures every user lands exactly
              where they expect, every time:
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3 color="rgba(13, 52, 49, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {deepLinkingItems.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
        <Content>
          <TextWrapper>
            <Title>Automated Messaging for User Engagement</Title>
            <Subtitle>
              Grovs simplifies messaging across your platforms, automatically
              showing targeted messages to users when they open your app or
              website:
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3 color="rgba(13, 52, 49, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {automatedMessagingItems.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default ProductInfo;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
    gap: 20px;
  overflow: hidden;

`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
display:flex;
align-items:center;
height:100%;
  @media (max-width: 990px) {
    display: none;
  }
`;
